import { Component } from "react";

import { Link, withRouter } from "react-router-dom";
import TitleBar from "../../components/ui/TitleBar";
import RectButton from "../../components/ui/button/RectButton";
import Input from "../../components/ui/Input";

import "./style.scss";
import OrderBox from "../../components/OrderBox";
import CreditCardInfo from "../../components/CreditCardInfo";
import InvalidCupomPopup from "../../components/Popup/InvalidCupomPopup";
import AppContext from "../../contexts/AppContext";
import AddCreditcardSectionBox from "../../components/AddCreditcardSectionBox";

class Basket extends Component {
    static contextType = AppContext;
    state = {
        addingCrediCard: false,
        discount: 0,
        tax: 2,
        coupon: null
    }

    componentDidMount() {
        window.addEventListener("resize", this.resizeHandler);
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.resizeHandler);
    }

    resizeHandler = () => {
        let innerWidth = window.innerWidth;
        if ((innerWidth <= 900 && this.lastWidth > 900) ||
            (innerWidth > 900 && this.lastWidth <= 900) ||
            (innerWidth > 750 && this.lastWidth <= 750) ||
            (innerWidth <= 750 && this.lastWidth > 750)) this.forceUpdate();
    }

    render() {
        this.lastWidth = window.innerWidth;
        let orders = [
            {
                sender: {
                    name: "Ari Kaplan",
                    address: "4206 Spruce Street",
                    address2: "Philadelphia, PA, 19104"
                },
                recipient: {
                    name: "Vidya Plainfield",
                    address: "1040 5th Ave",
                    address2: "New York, NY, 02653"
                },
                count: 4,
                price: 13.00,
                postage: 0.55,
                orderID: "1276930-B",
                sendDate: "November 6, 2020",
                giftCardPrice: 25,
                insert: "Business Card",
                writingStyle: "Proper Jeff",
                letter: `<span className="strong">Dear {{First Name}}</span><span>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam egestas a tellus eget malesuada. Pellentesque maximus egestas ornare. Integer sit amet erat tortor. Integer non dolor id massa lacinia porttitor non eget mi. Maecenas faucibus lectus lorem, eu commodo sapien dictum in. Cras semper et dolor vel mollis. Ut tempus, tellus nec vehicula faucibus, tellus libero egestas justo, non tristique orci purus ac dolor. Phasellus mollis risus vel purus viverra ultricies. Fusce interdum blandit biam.</span>`,
                image: "https://via.placeholder.com/146x189/004AAB"
            },
            {
                sender: {
                    name: "Ari Kaplan 2",
                    address: "4206 Spruce Street",
                    address2: "Philadelphia, PA, 19104"
                },
                recipient: {
                    name: "Vidya Plainfield",
                    address: "1040 5th Ave",
                    address2: "New York, NY, 02653"
                },
                count: 4,
                price: 13.00,
                postage: 0.55,
                orderID: "1276930-B",
                sendDate: "November 6, 2020",
                giftCardPrice: 25,
                insert: "Business Card",
                writingStyle: "Proper Jeff",
                letter: `<span className="strong">Dear {{First Name}}</span><span>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam egestas a tellus eget malesuada. Pellentesque maximus egestas ornare. Integer sit amet erat tortor. Integer non dolor id massa lacinia porttitor non eget mi. Maecenas faucibus lectus lorem, eu commodo sapien dictum in. Cras semper et dolor vel mollis. Ut tempus, tellus nec vehicula faucibus, tellus libero egestas justo, non tristique orci purus ac dolor. Phasellus mollis risus vel purus viverra ultricies. Fusce interdum blandit biam.</span>`,
                image: "https://via.placeholder.com/146x189/004AAB"
            },
            {
                sender: {
                    name: "Ari Kaplan 3",
                    address: "4206 Spruce Street",
                    address2: "Philadelphia, PA, 19104"
                },
                recipient: {
                    name: "Vidya Plainfield",
                    address: "1040 5th Ave",
                    address2: "New York, NY, 02653"
                },
                count: 4,
                price: 13.00,
                postage: 0.55,
                orderID: "1276930-B",
                sendDate: "November 6, 2020",
                giftCardPrice: 25,
                insert: "Business Card",
                writingStyle: "Proper Jeff",
                letter: `<span className="strong">Dear {{First Name}}</span><span>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam egestas a tellus eget malesuada. Pellentesque maximus egestas ornare. Integer sit amet erat tortor. Integer non dolor id massa lacinia porttitor non eget mi. Maecenas faucibus lectus lorem, eu commodo sapien dictum in. Cras semper et dolor vel mollis. Ut tempus, tellus nec vehicula faucibus, tellus libero egestas justo, non tristique orci purus ac dolor. Phasellus mollis risus vel purus viverra ultricies. Fusce interdum blandit biam.</span>`,
                image: "https://via.placeholder.com/146x189/004AAB"
            }
        ];

        let creditcard = this.state.addingCrediCard ? <AddCreditcardSectionBox onAddCard={() => this.setState({ addingCrediCard: false })} onCancel={() => this.setState({ addingCrediCard: false })} /> : null
        let total = 0;
        orders.forEach((obj) => total += (obj.price * obj.count))
        let { discount, tax } = this.state;

        return (
            <>
                <div className="full-container">
                    <section className="section-box my-basket">
                        <TitleBar title="My Basket" />
                        <OrderBox orders={orders} edit={true} />
                        <OrderBox plain={true} orders={orders} edit={true} />
                    </section>

                    <section className="section-box row checkout-info">
                        <CreditCardInfo onAddNew={() => this.setState({ addingCrediCard: !this.state.addingCrediCard })} />

                        {window.innerWidth <= 750 ? creditcard : null}

                        <section className="coupon-code">
                            <TitleBar title="Coupon Code" />
                            <div className="box">
                                <div className="row lock">
                                    <Input onChange={(value) => this.setState({ coupon: value })} />
                                    <RectButton text="APPLY" onClick={() => this.state.coupon ? this.setState({ discount: 32.5 }) : this.context.setPopup(<InvalidCupomPopup />)} />
                                </div>
                            </div>
                        </section>

                        {window.innerWidth > 750 && window.innerWidth <= 900 ? creditcard : null}

                        <section className="checkout">
                            <TitleBar title="Checkout" />
                            <div className="box">
                                <div className="column">
                                    <div className="row lock">
                                        <span>Total in Basket</span>
                                        <span>${parseFloat(total).toFixed(2)}</span>
                                    </div>
                                    {
                                        discount ?
                                            <div className="row lock">
                                                <span>Discount</span>
                                                <span>{`-$${parseFloat(discount).toFixed(2)}`}</span>
                                            </div> : null
                                    }
                                    <div className="row lock">
                                        <span>Tax</span>
                                        <span>{!tax ? "Free" : `$${parseFloat(tax).toFixed(2)}`}</span>
                                    </div>
                                    <div className="row lock strong">
                                        <span>Total</span>
                                        <span>${parseFloat(total - discount + tax).toFixed(2)}</span>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </section>

                    {window.innerWidth > 900 ? creditcard : null}

                    {this.context.testMode ? <section className="section-box warning"><strong>Warning:</strong>&nbsp; Account is in Test Mode. To send the note, plese turn off Test Mode in Sesstings.</section> : null}

                    <div className="order-actions column">
                        <Link className="place-bt" to="/on-its-way"><RectButton className="bigger" text="PLACE ORDER FOR $3.80" /></Link>
                        <Link className="uh sub-bt" to="/subscriptions">Subscribe and Save 15%</Link>
                    </div>
                </div>
            </>
        )
    }
}

export default withRouter(Basket);